<template>
    <modal v-show="show">
        <div slot="header">
            <h4>Envoyer un lien de paiement par mail</h4>
            <a @click="$emit('update:show',false)" href="#" class="btn pull-right closeWindow">
                <i class="fas fa-times fa-2x"></i>
            </a>
        </div>
        <div slot="body" v-show="booking.selectedCustomer.email">
            <label>À {{booking.selectedCustomer.fullName}}, le montant (en €) :
                <i data-toggle="tooltip" data-html="true" data-placement="right" title="<div id='tooltip'><p id='text'><img src='/img/Encouragement-tooltip.png'>Le prix proposé est calculé automatiquement sans prendre en compte votre TVA.<br>C'est à vous de décider du montant que vous demandez à votre client en le notant ici :</p></div>" class="icon-info"></i>
            </label>
            <input type="number" step="0.01" name="amount" placeholder="50" ref="input" class="form-control" v-model="amount" />
        </div>
        <div slot="footer" v-show="booking.selectedCustomer.email">
            <a class="btn btn-success billingSuccess" @click.prevent="publish()">Envoyer</a>
        </div>
        <div slot="body" v-show="!booking.selectedCustomer.email">
            Vous n'avez pas enregistré une adresse mail pour le client : {{booking.selectedCustomer.fullName}}
        </div>
        <div slot="footer" v-show="!booking.selectedCustomer.email">
            <a class="btn btn-success billingSuccess" @click.prevent="$emit('update:show',false)">Fermer</a>
        </div>
    </modal>
</template>

<script>
    export default {
        name: "sendPaymentLink",
        props : {
            show: {
                type: Boolean,
                default: false
            },
            booking:{
                type: Object,
                default: ()=>[]
            }
        },
        data(){
            return {
                amount : 0,
            }
        },
        created() {
            if(this.booking.activities){
                this.amount = this.booking.activities.reduce(function(a,b){
                    return parseFloat(a) + (parseFloat(b.pivot.price) * (b.pivot.quantity))
                }, 0)
            }
        },
        mounted: function(){
		    $('[data-toggle="tooltip"]').tooltip();
	    },
        methods:{
            publish(){
                if (this.amount != ''){
                    axios.post('calendar/event/booking/publish',{
                        eventId: this.booking.eventId,
                        amount: this.amount
                    })
                    .then(response => {
                        this.$emit('update:show',false)
                        this.$parent.showSendPaymentMailButton = false
                        this.$parent.$emit('close')
                        this.$parent.$emit('refetch-events')
                        this.$snotify.success('lien de paiement envoyé')
                    })
                    .catch(error => {
                        this.$snotify.error(error)
                    });
                }
            }
        },
    }
</script>
